import { render, staticRenderFns } from "./TransactionSummaryCard.vue?vue&type=template&id=cb3abf86&scoped=true&"
import script from "./TransactionSummaryCard.vue?vue&type=script&lang=js&"
export * from "./TransactionSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3abf86",
  null
  
)

export default component.exports